import { useMemo } from 'react';

import { getRecipeTypePath } from '~/src/common/components/Navigation/utils';
import { isTruthy } from '~/src/common/utils/guards';
import { useNavigation } from '~/src/queries/api-ecom/generated/api-ecom';

import { getCrumb } from '../utils';

/**
 * Génère le fil d'ariane à partir de l'identifiant ou du slug d'un type de recette.
 */
export const useBreadcrumbFromRecipeType = (idOrSlug: string | null) => {
  const { data: nav } = useNavigation();

  const crumbs = useMemo(() => {
    // Récupération du path de la catégorie demandée
    if (nav == null || idOrSlug == null) return null;
    const path = getRecipeTypePath(nav, idOrSlug);
    if (path == null) return null;

    // Type de recette
    return [
      'recipecategory' in path && getCrumb('recipe-category', path.recipecategory.item),
      'recipeType' in path && getCrumb('recipe-type', path.recipeType.item),
    ].filter(isTruthy);
  }, [nav, idOrSlug]);

  return crumbs;
};
